var _rect, _text, _text2, _text3, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroesTonightCover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "heroesGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#ff9a9e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#fecfef",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 8,
    fill: "url(#heroesGrad)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 85,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "HEROES")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 105,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: "bold",
    textAnchor: "middle",
    fill: "white"
  }, "TONIGHT")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 130,
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    textAnchor: "middle",
    fill: "white"
  }, "JANJI feat. JOHNNING")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 8,
    textAnchor: "middle",
    fill: "white"
  }, "NCS RELEASE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroesTonightCover);
export default __webpack_public_path__ + "static/media/heroes-tonight-cover.9c522569c9fbe4ce9abfacb66693ba7a.svg";
export { ForwardRef as ReactComponent };